//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { addObj, updateObj } from '@/api/visual/map';
export default {
  data: function data() {
    return {
      disableSubmit: false,
      wrapperCol: {
        xs: {
          span: 10
        },
        sm: {
          span: 16
        }
      },
      labelCol: {
        xs: {
          span: 5
        },
        sm: {
          span: 5
        }
      },
      title: '操作',
      visible: false,
      confirmLoading: false,
      model: {},
      validatorRules: {
        name: {
          rules: [{
            required: true,
            message: '请输入地图名称!'
          }]
        }
      },
      form: this.$form.createForm(this)
    };
  },
  methods: {
    add: function add() {
      this.edit({}, false);
    },
    edit: function edit(record, state) {
      var _this = this;

      this.disableSubmit = state;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {// this.model.data
      }

      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'name', 'data'));

        console.log('this.form', _this.form);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      if (!this.disableSubmit) {
        this.form.validateFields(function (err, values) {
          if (!err) {
            console.log('this.model', _this2.model);
            console.log('values', values);
            _this2.confirmLoading = true;
            var formData = Object.assign(_this2.model, values);
            _this2.confirmLoading = false;

            if (!_this2.model.id) {
              addObj(formData).then(function (res) {
                if (res.success) {
                  _this2.$message.success('新增成功');

                  _this2.$emit('ok');

                  _this2.visible = false;
                } else {
                  _this2.$message.error(res.message);
                }
              }).finally(function () {
                _this2.confirmLoading = false;
              });
            } else {
              updateObj(formData).then(function (res) {
                if (res.success) {
                  _this2.$message.success('修改成功');

                  _this2.$emit('ok');

                  _this2.visible = false;
                } else {
                  _this2.$message.error(res.message);
                }
              }).finally(function () {
                _this2.confirmLoading = false;
              });
            }
          }
        });
      } else {
        this.visible = false;
      }
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    }
  }
};